import React from "react";
import classNames from "classnames";
import { BankAccount } from "../../types/api/odt";
import { BankAccountCardType } from "../../types/components";

// ui components
import BankAccountToolTip from "../ODT/BankAccountToolTip";
import BankAccountCardActions from "./BankAccountCardActions";

type BankAccountCardProps = {
  bank: BankAccount;
  handleInfoTipModal: (title: string, content: string) => void;
  type?: BankAccountCardType;
  className?: string;
};

const BankAccountCard = ({ bank, handleInfoTipModal, type, className }: BankAccountCardProps) => {
  const countriesData = JSON.parse(localStorage.getItem("GET_COUNTRIES") || "[]");
  const destinationCountry = countriesData.find(
    (country: any) => country.iso === bank.destinationCountryIso
  );
  const destinationCountryName = destinationCountry?.name ?? "";
  const destinationCountryId = destinationCountry?.id ?? "";

  return (
    <article className={classNames("bwp-panel-row", className)} data-cy="bank-account-card">
      <p className="bold">{bank.accountName}</p>
      <p>*{bank.accountNumber}</p>
      <p>{bank.destinationCurrencyCode} to {destinationCountryName}</p>

      <div className="bwp-panel-row__info">
        {bank.moreInfo && (
          <BankAccountToolTip moreInfo={bank.moreInfo} handleInfoTipModal={handleInfoTipModal} />
        )}
      </div>

      <BankAccountCardActions
        bank={bank}
        type={type}
        destinationData={{ destinationCountryName, destinationCountryId }}
      />
    </article>
  );
};

export default BankAccountCard;